<template>
    <div class="famous-pedia-edit-history layout-sub-page">
        <!-- 1. 标题部分 -->
        <title-bar
            v-bind:className="'famous-pedia-eh-title-bar'"
            v-bind:titleData="titleData"
            v-bind:createGray="true"
            v-bind:backFunc="hidePediaEditHistory">
        </title-bar>

        <!-- 2. 编辑历史记录列表 -->
        <div class="famous-pedia-edit-history-content scroll-touch">
            <div class="famous-pedia-edit-history-list">
                <famous-edit-history-item
                    v-for="itemData in curPediaBaziEditHistoryList"
                    v-bind:key="itemData.id"
                    v-bind:source="itemData">
                </famous-edit-history-item>
            </div>
            <!-- <virtual-list
                id="FamousEditHistoryList"
                class="famous-pedia-edit-history-list overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="curPediaBaziEditHistoryList"
                :data-component="itemComponent"
                :estimate-size="30" 
                :item-class="'famous-pehl-item-box'" /> -->
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import FamousEditHistoryItem from '../../components/famouspedia/FamousEditHistoryItem.vue'
import { DOM } from '../../modules/dom'
export default {
    name: 'FamousPediaEditHistory',
    components: { TitleBar, FamousEditHistoryItem },
    computed: {
        curPediaBaziEditInfo() {
            return this.$store.state.famouspedia.curPediaBaziEditInfo
        },
        curPediaBaziEditHistoryList() {
            return this.$store.state.famouspedia.curPediaBaziEditHistoryList
        },
    },
    data() {
        return {
            titleData: {
                'titleText': '',
                'showCancel': false,
                'hideButton': true,
                'titleCreate': '被编辑次数：0'
            },
            itemComponent: FamousEditHistoryItem
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            this.$el.style.overflow = 'hidden';
            this.titleData.titleCreate = '被编辑次数：' + this.curPediaBaziEditInfo.editTime;

            // listDom
            var contentDom = document.getElementsByClassName('famous-pedia-edit-history-content')[0],
                listDom = document.getElementById('FamousEditHistoryList'),
                topDom = document.getElementsByClassName('famous-pedia-eh-title-bar')[0];
            if(contentDom && topDom) {
                contentDom.style.paddingTop = (topDom.clientHeight + 10) + 'px';
                contentDom.style.height = innerHeight + 'px';
            }
            if(listDom && topDom) {
                listDom.style.height = (innerHeight - topDom.clientHeight) + 'px';
            }
        },
        hidePediaEditHistory() {
            var curPath = this.$router.history.current.path;
                curPath = curPath.replace('/edithistory', '');
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                curPath = curPath.replace('famouspediaread/edithistory', 'famouspediaread')
            }
            this.$router.replace(curPath);
            DOM.showPageByClassName('famous-pedia-create-form');
            DOM.showPageByClassName('famous-comment-bottom-bar');
        }
    }
}
</script>